/**
 * This file contains all the logic related to route path
 */
import { getCompanyId } from './Amalgam';
import { getCachedOrderId, getInquiryForProduct } from './Order';
import { getProduct } from './Product';
import { isResellerBundleView, saveScrollPosition, SCROLL_POS_KEYS } from './Utils';

export const ROUTE_PATH = {
  // @Deprecated - REVIEW_ROUTE: '/s/review/:companyId',
  REVIEW_ROUTE: '/s/cart/:orderId',
  RESELLER_REVIEW_ROUTE: '/u/review/:companyId'
};

export const getReviewRoute = ({ isReseller } = {}) => {
  if (isReseller) {
    return ROUTE_PATH.RESELLER_REVIEW_ROUTE.replace(':companyId', getCompanyId());
  }

  return ROUTE_PATH.REVIEW_ROUTE.replace(':orderId', getCachedOrderId());
};

export const getProductDetailsRoute = (productId, { scrollElement, fromBundle, tabIndex } = {}) => {
  const inquiry = getInquiryForProduct(productId);

  if (!inquiry || !inquiry.catalogueSlugs) {
    return;
  }

  let routeProductId = productId;
  if (inquiry.product && inquiry.product.parentProductId) {
    const product = getProduct(inquiry.product.parentProductId);
    if (product && product.defaultVariantId) {
      routeProductId = product.defaultVariantId;
    }
  }

  if (scrollElement) {
    saveScrollPosition(scrollElement, SCROLL_POS_KEYS.REVIEW_PAGE);
  }

  const { companySlug, catalogueSlug, randomSlug } = inquiry.catalogueSlugs;
  if (isResellerBundleView(fromBundle)) {
    return `/t/gallery/${companySlug}/${catalogueSlug}/${randomSlug}/product/${routeProductId}?tabIndex=${tabIndex}`;
  }

  return `/s/gallery/${companySlug}/${catalogueSlug}/${randomSlug}/product/${routeProductId}`;
};
